import { render } from "./MallOrderTrend.vue?vue&type=template&id=46841ae6&scoped=true"
import script from "./MallOrderTrend.vue?vue&type=script&lang=js"
export * from "./MallOrderTrend.vue?vue&type=script&lang=js"

import "./MallOrderTrend.vue?vue&type=style&index=0&id=46841ae6&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/alice/alice_frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46841ae6"]])

export default __exports__